// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".add-to-cart[data-v-e2b36f58]{display:flex}.add-cart[data-v-e2b36f58]{width:100%}@media(min-width:1199.98px){.add-cart[data-v-e2b36f58]{margin-right:10px;width:auto}}.cart-icon[data-v-e2b36f58]{margin-right:3px;position:relative;top:2px}.loader--small[data-v-e2b36f58]{min-width:auto}.add-to-cart-mini[data-v-e2b36f58]{padding:10px 0 0 10px}.add-to-cart-mini .rounded-button--small.rounded-button--icon-only[data-v-e2b36f58]{height:34px;width:34px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
